export class User {
    public UserId: number;
    public UserName: string;
}

export  interface  User {
    EmployeeId: number;
    Pin: string;
}
